<ax-value-view type="RICH_TEXT" [value]="property.value"></ax-value-view>
